// extracted by mini-css-extract-plugin
export default {"container":"PenggunaForm_container__poklv","card":"PenggunaForm_card__zPLf6","title":"PenggunaForm_title__OQvEj"};